import { createRoot } from 'react-dom/client';

import { HandbookApp } from '@/handbook/HandbookApp';

import './handbook.css';

createRoot(document.getElementById('root')!).render(<HandbookApp />);
